"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import PageSkeleton from "@/app/(frontend)/[page_slug]/skeleton/PageSkeleton";

export const AboutItemSection = () => {
    const { trans } = useUtility();
    const { content, elements, loading } = useSection("about_item");

    if (loading) return <PageSkeleton />;

    return (
        <section className="about-item-section section-bg pb-60">
            <div className="container">
                {/* Section Header */}
                <div className="row">
                    <div className="col-12">
                        <div className="section-heading four">
                            <div className="row align-items-center">
                                <div className="col-xl-6">
                                    <h5 className="section-heading__title">{trans(content?.title)}</h5>
                                </div>
                                <div className="col-xl-6">
                                    <p className="section-heading__desc">{trans(content?.description)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Feature Items */}
                <div className="row gy-4 about-item-wrapper">
                    {elements?.map((item, idx) => (
                        <div className="col-md-6" key={idx}>
                            <div className="about-item">
                                <span className="about-item__icon">
                                    <span
                                        className={`about-item__icon-inner ${idx === 0 ? "one" : idx === 1 ? "two" : ""}`}
                                        dangerouslySetInnerHTML={{
                                            __html: item.svg_icon || "",
                                        }}
                                    />
                                </span>
                                <div className="about-item__content">
                                    <h6 className="about-item__title">{trans(item.title)}</h6>
                                    <p className="about-item__desc">{trans(item.description)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
